import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api/api.service';
import {
  ProgrammeDetailResponseModel,
  ProgrammeListParams,
  ProgrammeListResponseModel,
  ReviewListParams,
  ReviewListResponseModel,
} from './programme.model';

@Injectable({ providedIn: 'root' })
export class ProgrammeService {
  private readonly api = inject(ApiService);

  // Retrieves programmes; `params` drives server-side pagination and search.
  getAllProgrammes(params?: ProgrammeListParams): Observable<ProgrammeListResponseModel> {
    return this.api.post<ProgrammeListResponseModel>('v2/experience/b2b/list', params);
  }

  // Retrieves a single programme by slug.
  getProgramme(slug: string): Observable<ProgrammeDetailResponseModel> {
    return this.api.post<ProgrammeDetailResponseModel>('v2/experience/b2b', { slug });
  }

  // Retrieves paginated reviews for one programme.
  getReviews(params: ReviewListParams): Observable<ReviewListResponseModel> {
    return this.api.post<ReviewListResponseModel>('v2/activity/rnr', params);
  }
}
